const TaskThreadTestIdsScope = {
  TASK_THREAD: 'task-thread',
};

export const TaskThreadTestIds = {
  THREAD: TaskThreadTestIdsScope.TASK_THREAD,
  EMPTY: `${TaskThreadTestIdsScope.TASK_THREAD}.empty`,
  COMPOSER: `${TaskThreadTestIdsScope.TASK_THREAD}.composer`,
  COMPOSER_MESSAGE_INPUT: `${TaskThreadTestIdsScope.TASK_THREAD}.composer-message-input`,
  COMPOSER_AUDIENCE_SELECT: `${TaskThreadTestIdsScope.TASK_THREAD}.composer-audience-select`,
  COMPOSER_SEND_BUTTON: `${TaskThreadTestIdsScope.TASK_THREAD}.composer-send-button`,

  getEntryId: recordId => `${TaskThreadTestIdsScope.TASK_THREAD}.entry-${recordId}`,
  getEntryAudienceTagId: recordId =>
    `${TaskThreadTestIdsScope.TASK_THREAD}.entry-${recordId}-audience`,
};
